import {TFunction} from 'i18next';
import {CommandeProblem} from 'api-types/ffconnect';

// Permet de parser et de modifier (si nécessaire) les messages d'erreurs
export const useProblemParser = () => {
  const parseProblemMessage = (t: TFunction, problem: CommandeProblem) => {
    const heure_a_atteindre =
      problem.heure_a_atteindre?.replace(':', 'h') ?? '';
    const montant_a_atteindre = problem.montant_a_atteindre ?? 0;
    const poids_a_atteindre = problem.poids_a_atteindre ?? 0;
    const surcout_a_valider = problem.surcout_a_valider ?? 0;

    const niveau_problem = problem.niveau;

    if (problem.code === 'hors_delai') {
      const niveau_problem = problem.niveau;
      if (niveau_problem === 'tolerance') {
        return t('panier.error.hors_delai.tolerance', {heure_a_atteindre});
      }
      if (niveau_problem === 'surcout') {
        return t('panier.error.hors_delai.surcout', {
          surcout_a_valider,
          heure_a_atteindre,
        });
      }
      if (niveau_problem === 'bloquant') {
        return t('panier.error.hors_delai.bloquant', {heure_a_atteindre});
      }
    }

    if (problem.code === 'franco_poids_prix_non_atteint') {
      const parseCause = (
        montant_a_atteindre_message: string,
        poids_a_atteindre_message: string,
        montant_a_atteindre_et_poids_a_atteindre_message: string,
      ) => {
        if (problem.montant_a_atteindre && problem.poids_a_atteindre) {
          return montant_a_atteindre_et_poids_a_atteindre_message;
        }
        if (problem.montant_a_atteindre) {
          return montant_a_atteindre_message;
        }
        if (problem.poids_a_atteindre) {
          return poids_a_atteindre_message;
        }
        return problem.message;
      };
      if (niveau_problem === 'tolerance') {
        return parseCause(
          t('panier.error.franco.tolerance.montant_a_atteindre', {
            montant_a_atteindre,
          }),
          t('panier.error.franco.tolerance.poids_a_atteindre', {
            poids_a_atteindre,
          }),
          t(
            'panier.error.franco.tolerance.montant_a_atteindre_et_poids_a_atteindre',
            {montant_a_atteindre, poids_a_atteindre},
          ),
        );
      }
      if (niveau_problem === 'surcout') {
        return parseCause(
          t('panier.error.franco.surcout.montant_a_atteindre', {
            surcout_a_valider,
            montant_a_atteindre,
          }),
          t('panier.error.franco.surcout.poids_a_atteindre', {
            surcout_a_valider,
            poids_a_atteindre,
          }),
          t(
            'panier.error.franco.surcout.montant_a_atteindre_et_poids_a_atteindre',
            {surcout_a_valider, montant_a_atteindre, poids_a_atteindre},
          ),
        );
      }
      if (niveau_problem === 'bloquant') {
        return parseCause(
          t('panier.error.franco.bloquant.montant_a_atteindre', {
            montant_a_atteindre,
          }),
          t('panier.error.franco.bloquant.poids_a_atteindre', {
            poids_a_atteindre,
          }),
          t(
            'panier.error.franco.bloquant.montant_a_atteindre_et_poids_a_atteindre',
            {montant_a_atteindre, poids_a_atteindre},
          ),
        );
      }
    }

    return problem.message;
  };

  return {
    parseProblemMessage: parseProblemMessage,
  };
};
